var map = {
	"./+forgot/forgot.module": [
		"../../../../../src/app/+auth/+forgot/forgot.module.ts",
		"forgot.module"
	],
	"./+locked/locked.module": [
		"../../../../../src/app/+auth/+locked/locked.module.ts",
		"common",
		"locked.module"
	],
	"./+login/login.module": [
		"../../../../../src/app/+auth/+login/login.module.ts",
		"login.module"
	],
	"./+register/register.module": [
		"../../../../../src/app/+auth/+register/register.module.ts",
		"register.module"
	],
	"app/+areas/+assembly1/assembly1.module": [
		"../../../../../src/app/+areas/+assembly1/assembly1.module.ts",
		"common",
		"assembly1.module"
	],
	"app/+areas/+assembly2/assembly2.module": [
		"../../../../../src/app/+areas/+assembly2/assembly2.module.ts",
		"common",
		"assembly2.module"
	],
	"app/+areas/+body-weld/body-weld.module": [
		"../../../../../src/app/+areas/+body-weld/body-weld.module.ts",
		"common",
		"body-weld.module"
	],
	"app/+areas/+paint1/paint1.module": [
		"../../../../../src/app/+areas/+paint1/paint1.module.ts",
		"common",
		"paint1.module"
	],
	"app/+areas/+paint2/paint2.module": [
		"../../../../../src/app/+areas/+paint2/paint2.module.ts",
		"common",
		"paint2.module"
	],
	"app/+areas/+plastics/plastics.module": [
		"../../../../../src/app/+areas/+plastics/plastics.module.ts",
		"common",
		"plastics.module"
	],
	"app/+areas/+powertrain/powertrain.module": [
		"../../../../../src/app/+areas/+powertrain/powertrain.module.ts",
		"common",
		"powertrain.module"
	],
	"app/+areas/+stamping/stamping.module": [
		"../../../../../src/app/+areas/+stamping/stamping.module.ts",
		"common",
		"stamping.module"
	],
	"app/+areas/areas.module": [
		"../../../../../src/app/+areas/areas.module.ts",
		"areas.module"
	],
	"app/+auth/auth.module": [
		"../../../../../src/app/+auth/auth.module.ts",
		"auth.module"
	],
	"app/+home/home.module": [
		"../../../../../src/app/+home/home.module.ts",
		"common",
		"home.module"
	],
	"app/+settings/settings.module": [
		"../../../../../src/app/+settings/settings.module.ts",
		"common",
		"settings.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /Users/alex/Documents/JC/JC3 3/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main